import React, { useState } from 'react';
import { Container, Form, Button, Row, Col, Card } from 'react-bootstrap';
import { FaEnvelope, FaPhone, FaMapMarkerAlt } from 'react-icons/fa';
import axios from 'axios';

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post('https://tekstas.com/test/api/contact', formData);
      // Form başarıyla gönderildi
      setFormData({ name: '', email: '', subject: '', message: '' });
    } catch (error) {
      console.error('Error:', error);
      alert('Error sending message. Please try again.');
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <Container className="py-5">
      <h2 className="text-center mb-4">Contact Us</h2>
      <Row className="g-4">
        <Col md={5}>
          <Card className="h-100">
            <Card.Body>
              <h3 className="mb-4">Contact Information</h3>
              
              <div className="mb-4">
                <h5 className="d-flex align-items-center">
                  <FaMapMarkerAlt className="me-2" /> Address
                </h5>
                <p className="ms-4 mb-0">123 Museum Street</p>
                <p className="ms-4 mb-0">Vilnius, Lithuania</p>
              </div>

              <div className="mb-4">
                <h5 className="d-flex align-items-center">
                  <FaPhone className="me-2" /> Phone
                </h5>
                <p className="ms-4 mb-0">+370 123 45678</p>
              </div>

              <div className="mb-4">
                <h5 className="d-flex align-items-center">
                  <FaEnvelope className="me-2" /> Email
                </h5>
                <p className="ms-4 mb-0">info@virtualmuseum.com</p>
              </div>

              <div>
                <h5>Opening Hours</h5>
                <p className="ms-4 mb-0">Monday - Friday: 9:00 - 18:00</p>
                <p className="ms-4 mb-0">Saturday - Sunday: 10:00 - 16:00</p>
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Col md={7}>
          <Card>
            <Card.Body>
              <h3 className="mb-4">Send us a Message</h3>
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label>Name</Form.Label>
                  <Form.Control 
                    type="text" 
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Enter your name" 
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Email</Form.Label>
                  <Form.Control 
                    type="email" 
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Enter your email" 
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Subject</Form.Label>
                  <Form.Control 
                    type="text" 
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    placeholder="Enter subject" 
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Message</Form.Label>
                  <Form.Control 
                    as="textarea" 
                    rows={5} 
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Enter your message" 
                  />
                </Form.Group>

                <Button variant="primary" type="submit" className="w-100">
                  Send Message
                </Button>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default ContactPage;